import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

/**
 * Reusable time slot selector with 15-minute intervals
 * Used for: Availability schedules, time selection
 */
const TimeSlotSelector = ({ value, onChange, placeholder = "Select time", disabled = false, className = '', minTime = null }) => {
  // Generate time slots in 15-minute intervals from 00:00 to 23:45
  const generateTimeSlots = () => {
    const slots = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 15) {
        const hourStr = String(hour).padStart(2, '0');
        const minStr = String(minute).padStart(2, '0');
        const time = `${hourStr}:${minStr}`;
        
        // Skip times before minTime if provided
        if (minTime) {
          const [minHour, minMin] = minTime.split(':').map(Number);
          const currentMinutes = hour * 60 + minute;
          const minMinutes = minHour * 60 + minMin;
          
          if (currentMinutes <= minMinutes) {
            continue; // Skip this time slot
          }
        }
        
        // Format for display (12-hour)
        const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const display = `${displayHour}:${minStr} ${ampm}`;
        
        slots.push({ value: time, label: display });
      }
    }
    return slots;
  };

  const timeSlots = generateTimeSlots();

  return (
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger className={`${disabled ? 'bg-gray-100 text-gray-400' : ''} ${className}`}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="max-h-60">
        {timeSlots.map((slot) => (
          <SelectItem key={slot.value} value={slot.value}>
            {slot.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default TimeSlotSelector;
